<script setup>
import { defineProps } from "vue";
import JsonTreeView from "@/components/MyStudents/Submissions/components/SubmissionsInformation/components/JsonTreeView";
import Modal from "@/components/modals/Modal.vue";
import CloseIconLarge from "@/components/shared/icons/CloseIconLarge.vue";

const props = defineProps({
  open: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    required: false,
    default: null,
  },
  data: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(["closeModal"]);
const onCancel = () => {
  emit("closeModal");
};
</script>
<template>
  <Modal
    data-testid="tableu-report-modal"
    :open="props?.open"
    :show-logo="false"
    :close-on-outside-click="false"
    :rounded="false"
    :show-close-button="false"
    content-padding-class="p-5 sm:px-16 md:px-10 sm:py-16 sm:pb-8"
  >
    <template #modalHeader>
      <div class="flex flex-row justify-between h-[50px] bg-teal-accent items-center absolute inset-0 px-5 py-3">
        <h2 v-if="props?.title" class="text-indigo-base font-bold ml-1 text-sm">{{ props.title }}</h2>
        <button class="h-6 w-6" data-testid="close-modal-button" @click="onCancel">
          <CloseIconLarge />
        </button>
      </div>
    </template>
    <template #modal-content>
      <div class="flex flex-col mt-8 space-y-6 text-indigo-base min-h-1000px font-montserrat">
        <JsonTreeView
          v-if="Object.keys(data).length > 0"
          data-testid="tableau-report-json-view"
          :data="data"
          legacy
          class="w-full md:w-full"
        />
      </div>
    </template>
  </Modal>
</template>
